import React from 'react'
import { connect } from 'react-redux'
import './index.scss'
import groupBy from 'lodash/groupBy'
import isEmpty from 'lodash/isEmpty'
import { BarChart, StackedBarChart } from '../../../common/charts'
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LabelList } from 'recharts'

class HarvestDataView extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      dataByWeapon: {},
      yearlyAvgDays: [],
      yearlyHunters: [],
      selectedWeaponId: '0',
      genderKey: 'any'
    }
    this.setWeapon = this.setWeapon.bind(this)
    this.setGender = this.setGender.bind(this)
  }

  componentDidMount() {
    const { unitData } = this.props,
      { harvestData } = unitData,
      dataByWeapon = groupBy(harvestData, 'weaponId'),
      yearlyAvgDays = dataByWeapon[0].map(entry => {
        return {
          year: entry.year,
          average: Math.round((entry.huntingDays / entry.totalHunters) * 10) / 10
        }
      }),
      yearlyHunters = dataByWeapon[0].map(entry => {
        return {
          year: entry.year,
          hunters: entry.totalHunters
        }
      })
    this.setState({ yearlyAvgDays, yearlyHunters, dataByWeapon })
  }

  setWeapon(weapon) {
    this.setState({ selectedWeaponId: weapon })
  }

  setGender(gender) {
    this.setState({ genderKey: gender })
  }

  getLabel(props) {
    const { x, y, value, index } = props,
      transform = index === 0 ? 'translate(25)' : ''
    return (
      <text y={y}
        x={x}
        transform={transform}
        fontSize='12'
        textAnchor='end'
        fill='#FFF'>
        {value}
      </text>
    )
  }

  render() {
    const { genderKey, dataByWeapon, selectedWeaponId } = this.state,
      { weaponTypes } = this.props,
      genderKeys = ['any', 'female', 'male', 'young']
    if (isEmpty(dataByWeapon)) {
      return null
    }
    const graphData = dataByWeapon[selectedWeaponId].map(data => {
      const keyTail = genderKey == 'female' ?
        'Female' : genderKey == 'male' ?
          'Male' : 'Young',
        mScale = data.totalHarvestedMale / data.totalHarvest,
        fScale = data.totalHarvestedFemale / data.totalHarvest,
        mPer = Math.round((data.successRate * mScale) * 10000) / 100,
        fPer = Math.round((data.successRate * fScale) * 10000) / 100
      return {
        year: data.year,
        mRate: mPer,
        fRate: fPer
      }
    })
    return (
      <div className='hunt-modal-harvest-container' >
        <div className='hunt-modal-harvest-entry-thin'>
          <div className='hunt-modal-harvest-entry-header'>
            <p className='vertical-center'>Hunters</p>
          </div>
          <div className='hunt-modal-harvest-entry-graph'>
            {
              this.state.yearlyHunters.length > 0 ?
                <BarChart data={this.state.yearlyHunters}
                  barColor='#ff6800'
                  xKey='year'
                  yKey='hunters' /> : null
            }
          </div>
        </div>

        <div className='hunt-modal-harvest-entry-thin'>
          <div className='hunt-modal-harvest-entry-header'>
            <p className='vertical-center'>Avg. Hunting Days</p>
          </div>
          <div className='hunt-modal-harvest-entry-graph'>
            {
              this.state.yearlyAvgDays.length > 0 ?
                <BarChart data={this.state.yearlyAvgDays}
                  barColor='#ff6800'
                  xKey='year'
                  yKey='average' /> : null
            }
          </div>
        </div>

        <div className='hunt-modal-harvest-entry-wide'>
          <div className='hunt-modal-harvest-entry-header'>
            <p className='vertical-center'>Harvest Success</p>
          </div>
          <div className='hunt-modal-harvest-entry-graph'>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <select className='harvest-select'
                onChange={(e) => {
                  this.setWeapon(e.target.value)
                }}
                value={selectedWeaponId}>
                {
                  Object.keys(dataByWeapon).map(weaponKey => {
                    const weaponData = dataByWeapon[weaponKey][0]
                    if (weaponKey == 0) {
                      return null
                    } else {
                      const weapon = weaponTypes.find(weaponInfo => weaponInfo.id == weaponData.weaponId)
                      return <option key={`weapon-option-${weaponKey}`} value={weaponKey}>{weapon.name}</option>
                    }
                  })}
              </select>
              <select className='harvest-select'
                onChange={(e) => {
                  this.setGender(e.target.value)
                }}>
                {
                  genderKeys.map(key => {
                    const { selectedWeaponId } = this.state,
                      weaponData = dataByWeapon[selectedWeaponId][0]
                    if (key == 'any') {
                      return (
                        <option value={[weaponData['totalHarvestedFemale'],
                        weaponData['totalHarvestedMale'],
                        weaponData['totalHarvestedYoung']]}>
                          Any
                        </option>
                      )
                    } else {
                      const keyTail = key == 'female' ?
                        'Female' : key == 'male' ?
                          'Male' : 'Young'
                      return (
                        <option value={[weaponData[`totalHarvested${keyTail}`]]}>
                          {weaponData[`${key}DisplayName`]}
                        </option>
                      )
                    }
                  })
                }
              </select>
            </div>
            <div style={{ width: '100%', height: 'calc(100% - 40px)' }}>
              {/* <StackedBarChart xKey={'year'} yKey1={'mPer'} yKey2={'fPer'} data={graphData} /> */}
              <ResponsiveContainer width='100%' height='100%'>
                <AreaChart margin={{ top: 10, left: 10, bottom: 10, right: 10 }} data={graphData}>
                  <XAxis dataKey='year' />
                  <YAxis />
                  <Area type='monotone' dataKey='mRate' stroke='#FF6800' fill='#FF6800' label={this.getLabel}>
                  </Area>
                  <Area type='monotone' dataKey='fRate' stroke='#BE4014' fill='#BE4014' label={this.getLabel}>
                  </Area>
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </div >
    )
  }
}

const mapStateToProps = state => ({
  weaponTypes: state.weaponTypes
})

const mapDispatchToProps = dispatch => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(HarvestDataView)
